import React from 'react';

import Description from '../FormFields/Description';
import WhenShouldBeCompleted from '../FormFields/When/WhenShouldBeCompleted';
import Who from '../FormFields/Who/Who';
import Error from './Error';

export const Task = () => {
  return (
    <div className="activity_modal">
      <Description />
      <WhenShouldBeCompleted />
      <Who /> {/* NOTE: Keep Who as the last element of ActivityModal */}
      <Error />
    </div>
  );
};

export default Task;
